import { BaseModal } from '@cokitchen/cokitchen-components';
import React, { FC, ReactNode } from 'react';
import { ReactComponent as TitleIcon } from 'assets/icons/update-surge-modal-icon.svg';

type ResolveModalProps = {
  show: boolean;
  type?: 'resolved' | 'unresolved';
  children?: ReactNode;
  onClose: (refetchData?: boolean) => void;
};

const ResolvedModal: FC<ResolveModalProps> = ({ show, onClose }) => {
  return (
    <div className='relative'>
      <BaseModal
        isOpen={show}
        title=''
        titleIcon={<TitleIcon />}
        titleIconColor='info'
        onRequestClose={() => onClose()}>
        <div className='absolute left-44 top-8'>
          <div className='flex gap-[7px] items-center'>
            <p className='font-semibold text-[#1A1A1A] text-[20px]'>#26AB56</p>
            <p className='text-xs border border-green-4 px-[10px] rounded-[40px] bg-[#c1e9b9] text-green-5'>
              Resolved
            </p>
          </div>
        </div>

        <div className='scroll-container text-[14px h-[470px] text-[#1A1A1A] px-3 pt-5 overflow-y-scroll'>
          <div className='flex justify-between border-[#EAEBEB] border-b pb-[7px]'>
            <p className='text-[#858585]'>Name</p>
            <p>Adebayo Micheal</p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>CS Rep Assigned</p>
            <p>Adebayo Micheal</p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Resolved by</p>
            <p>Adebayo Micheal</p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Issue</p>
            <p className='w-[75%] text-right'>
              Proin nam ac lectus pharetra. Venenatis pretium magna cursus arcu felis non
              vestibulum. Dignissim augue sem enim montes mauris cursus.
            </p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Category</p>
            <p>Review</p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Resolution</p>

            <p className='w-[75%] text-right'>
              Proin nam ac lectus pharetra. Venenatis pretium magna cursus arcu felis non
              vestibulum. Dignissim augue sem enim montes mauris cursus.
            </p>
          </div>

          <div className='flex justify-between border-[#EAEBEB] border-b py-[20px]'>
            <p className='text-[#858585]'>Date </p>
            <p className='text-[#595959]'>10th Jul, 2023, 12:32PM</p>
          </div>
        </div>
      </BaseModal>
    </div>
  );
};

export default ResolvedModal;
